import { driver } from '@/data'

import { useFilterSheet } from '@/components/sheet/store/hooks/useFilterSheet'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export const useSheetCounts = ({ sheetId }: { sheetId: string }) => {
  const { filters } = useFilterSheet(sheetId)

  const {
    data: sheetCountsData,
    refetch,
    error,
  } = useQuery({
    queryKey: ['sheetCounts', sheetId, filters],
    queryFn: async () => {
      try {
        return await driver.getCounts({ sheetId, ...filters })
      } catch (err) {
        console.error('Error fetching sheet counts:', err)
        return null
      }
    },
    // Don't retry on error to prevent render-time state updates
    retry: false,
    // Prevent immediate refetch on mount which could trigger state updates during render
    staleTime: 1000,
    // Only fetch when we have valid inputs
    enabled: !!sheetId && !!filters,
  })

  // Memoize the returned object to ensure stable references
  const result = useMemo(
    () => ({
      sheetCounts: sheetCountsData,
      refetch,
      error,
    }),
    [sheetCountsData, refetch, error]
  )

  return result
}
